module.exports = __webpack_public_path__ + "media/images/referral1-1b901042.png";